import React from 'react';
import { Field } from 'formik';
import PropTypes from 'prop-types';

import { _Label as Label } from '../../Styled/Label';
import { _FieldDescription as FieldDescription } from '../../Styled/FieldDescription';
import { _MultipleChoiceWrapper as MultipleChoiceWrapper } from './MultipleChoice.style';

export const MultipleChoice = ({ id, props }) => {
  const { label, options, required, description } = props;
  const optionsArray = options.split('\n');

  return (
    <MultipleChoiceWrapper>
      <Label htmlFor={id}>{`${label} ${required ? '*' : ''}`}</Label>
      {description ? <FieldDescription>{description}</FieldDescription> : ''}
      {optionsArray.map((option, index) => (
        <div key={index}>
          <Field
            id={`${id}-${option}`}
            name={`form.${props.label}`}
            type='checkbox'
            value={option}
            required={required}
          />
          <Label htmlFor={`${id}-${option}`}>{option}</Label>
        </div>
      ))}
    </MultipleChoiceWrapper>
  );
};

MultipleChoice.propTypes = {
  id: PropTypes.string.isRequired,
  props: PropTypes.shape({
    label: PropTypes.string.isRequired,
    options: PropTypes.string.isRequired,
    required: PropTypes.bool,
    name: PropTypes.string,
  }).isRequired,
};
